//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import customerReport from '~/graphql/queries/customerReport';

export default {
  props: {
    reportSpecies: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    loaded: false,
    report: {},
    speciesSearch: '',
    speciesType: '',
    changes: false,
    showProblems: false,
    showComments: false,
  }),
  mounted() {
    this.$apollo.query({
      query: customerReport,
      variables: {
        uuid: this.$route.params.uuid,
        access_token: this.$route.query.t,
      },
    }).then((data) => {
      this.report = data.data.customerReport;
      this.loaded = true;
    });
  },
};
